import moment from "moment";
export const BERLIN_TIME_ZONE = "Europe/Berlin";
// The backend runs in Berlin time (config.time_zone) and buckets stats by Berlin dates.
// Taking "today" from the browser instead puts translators west of Berlin into the previous
// day — and around midnight on the first of a month into the previous month — so they would
// be shown a different period than the one the backend considers current.
export function currentBerlinDay() {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: BERLIN_TIME_ZONE,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(new Date());
    const part = (type) => { var _a; return (_a = parts.find((p) => p.type === type)) === null || _a === void 0 ? void 0 : _a.value; };
    return moment(`${part("year")}-${part("month")}-${part("day")}`, "YYYY-MM-DD");
}
